<template>
  <div class="school content">
     <div class="head">
        {{title}}
     </div>

     <div class="yuanxiaoku-sch-list-page">
        <div class="yuanxiaoku-sch-list-pages">
           <div style="width: 100%;display: flex;align-items: center;justify-content: center;padding-top: 10px;padding-bottom: 10px;">
             <el-input size="medium" placeholder="请输入院校名称" @keyup.enter.native="search()" style="width: 300px;" v-model="form.collegeName"></el-input>
             <el-input size="medium" placeholder="请输入专业名称" @keyup.enter.native="search()" style="width: 300px;margin-left: 10px;" v-model="form.majorName" v-if="n=='shuangyiliu' || n=='tesezhuanye'"></el-input>
             <el-button type="success" style="margin-left: 10px;" size="medium" @click="search">搜索</el-button>
           </div>
           <el-form :model="form">
             <div style="display: flex;margin-top: 20px;">
               <div class="pri01">院校所在地</div>
               <div class="item-options">
                   <span class="span" @click="titleClick('')" :class="[form.collegeProvince==''?'spanselect':'']">全部</span>
                   <span class="span" @click="titleClick(item.title)" v-for="(item,i) in provinceArr" :class="[item.title==form.collegeProvince?'spanselect':'']" :key="i">
                     {{item.title}}
                   </span>
               </div>
             </div>
             <div style="display: flex;margin-top: 20px;" v-if="n!='zhongwai' && n!='baoyan' && n!='tuimian' && n!='shuangyiliu' && n!='tesezhuanye'">
               <div class="pri01">学历层次</div>
               <div class="item-options">
                   <span class="span" @click="collegeLevelClick('')" :class="[form.collegeLevel==''?'spanselect':'']">全部</span>
                   <span class="span" @click="collegeLevelClick(item)" v-for="(item,i) in ['本科','专科']" :class="[item==form.collegeLevel?'spanselect':'']" :key="i">
                     {{item}}
                   </span>
               </div>
             </div>
             <div style="display: flex;margin-top: 20px;" v-if="n!='zhongwai' && n!='baoyan' && n!='tuimian' && n!='shuangyiliu' && n!='tesezhuanye'">
              <div class="pri01">院校性质</div>
               <div class="item-options">
                   <span class="span" @click="collegeNaturelClick('')" :class="[form.collegeNature==''?'spanselect':'']">全部</span>
                   <span class="span" @click="collegeNaturelClick(item)" v-for="(item,i) in collegeNatureArr" :class="[item==form.collegeNature?'spanselect':'']" :key="i">
                     {{item}}
                   </span>
               </div>
             </div>
             <div style="display: flex;margin-top: 20px;" v-if="n!='zhongwai' && n!='baoyan'">
              <div class="pri01">院校类型</div>
               <div class="item-options">
                   <span class="span" @click="collegeTypeClick('')" :class="[form.collegeType==''?'spanselect':'']">全部</span>
                   <span class="span" @click="collegeTypeClick(item)" v-for="(item,i) in collegeTypeArr" :class="[item==form.collegeType?'spanselect':'']" :key="i">
                     {{item}}
                   </span>
               </div>
             </div>
           </el-form>

        </div>
     </div>
     <div class="list">
       <el-empty description="暂无数据" v-if="list.length==0"></el-empty>
       <div class="lists" v-if="list.length>0" v-loading="loading">
          <div class="listcon" :style="{'margin-left':i%2!==0?'auto':'0px'}"  @click="detail(item)" style="cursor: pointer;" v-for="(item,i) in list" :key="i">
            <div class="logo">
              <img :src="item.collage_logo" alt="">
            </div>
            <div class="info-box">
              <div class="sch-title">{{item.collegeName}}
                <el-button type="success" v-if="n=='zhaosheng'">查看招生简章</el-button>
              </div>
              <div class="address" v-if="n!='baoyan' && n!='paihang'">
                <img src="../../assets/dingwei.png" class="dingwei" alt="">
                {{item.collegeProvince}}
                <div style="display: flex;" v-if="n!='shuangyiliu' && n!='tesezhuanye' && n!='zhongwai'">
                  <span class="col-line">|</span>
                <span>{{item.collegeAdmin}}</span>
                </div>
                <div style="display: flex;align-items: center;margin-left: 20px;">
                  <span>{{item.collegeLevel}}<span class="col-line">|</span></span>
                  <span>{{item.collegeType}}<span class="col-line">|</span></span>
                  <span>{{item.collegeNature}}<span class="col-line">|</span></span>
                </div>
              </div>
              <div class="sch-level" v-if="n!='tuimian' && n!='shuangyiliu' && n!='tesezhuanye' && n!='baoyan' && n!='zhaosheng' && (item.two_yiliu=='是' || item.is985=='是' || item.is211=='是' || item.yanjiuY)">
                <div style="display: flex;">
                  <span v-if="item.two_yiliu=='是'">双一流 <span class="col-line">|</span></span>
                <span v-if="item.is985=='是'">985 <span class="col-line">|</span></span>
                <span v-if="item.is211=='是'">211 <span class="col-line">|</span></span>
                <span v-if="item.yanjiuY">研究生院 <span class="col-line">|</span></span>
                </div>
              </div>
              <div class="sch-level" v-if="n=='paihang' && (item.ruan_pai || item.xiaoyou_paiming)">
                  <div v-if="item.ruan_pai">软科排名:{{item.ruan_pai || "--"}}</div>
                  <div style="margin-left: 30px;" v-if="item.xiaoyou_paiming">校友会排名:{{item.xiaoyou_paiming || "--"}}</div>
              </div>
              <div class="sch-levels two" v-if="n=='shuangyiliu'" style="width: 100%;font-weight: bold;">
                双一流学科：{{item.tw0_jianshe}}
              </div>
              <div class="sch-levels two" v-if="n=='tesezhuanye'" style="width: 100%;font-weight: bold;">
                国家特色专业：{{item.tese_major}}
              </div>
              <div class="sch-level" v-if="n=='baoyan'" style="width: 100%;">
                 <div style="display: flex;align-items: center;">
                   {{current_year}}年保研率:
                   <div style="color: red;">{{item.one_baoyan_lv?(item.one_baoyan_lv * 100).toFixed(2) + '%':"--"}}</div>
                </div>
                <div style="display: flex;align-items: center;margin-left: 20px;">
                   {{current_year-1}}年保研率:
                   <div style="color: red;">{{item.two_baoyan_lv?(item.two_baoyan_lv * 100).toFixed(2) + '%':"--"}}</div>
                </div>
                <div style="display: flex;align-items: center;margin-left: 20px;">
                   {{current_year-2}}年保研率:
                   <div style="color: red;">{{item.three_baoyan_lv?(item.three_baoyan_lv * 100).toFixed(2) + '%':"--"}}</div>
                </div>
              </div>
            </div>
          </div>
       </div>
     </div>
     <div style="width: 100%;display: flex;align-items: center;justify-content: center;padding-bottom: 30px;">
            <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="form.page"
                  :page-sizes="[100]"
                  :page-size="form.limit"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total">
                </el-pagination>
          </div>
  </div>
</template>

<script>
  import {mapGetters} from "vuex"
  import { collegeList } from "@/api/gw/zonghe"
  import cityJson from "@/utils/city.json"
  export default {
    computed:{
      ...mapGetters(['isLogin',"userinfo"]),
    },
    data(){
      return{
         form:{
           page:1,
           limit:100,
           collegeName:"",//院校名称
           collegeProvince:"",//院校所在地 省份
           collegeLevel:"",//学历层次  本科 专科
           collegeNature:"",//中外合作办学 内地与港澳台地区合作办学
           collegeType:"",
           majorName:"",
           type:1,
         },
         fromList:1,
         i:null,
         collegeNatureArr:["公办","民办","独立学院","解放军院校","中外合作办学","内地与港澳台地区合作办学"],
         provinceArr:cityJson,
         loading:false,
         total:0,
         list:[],
         n:"",
         title:"院校信息库",
         current_year:"",
         collegeTypeArr: [
        "综合类",
        "理工类",
        "医药类",
        "农林类",
        "艺术类",
        "民族类",
        "语言类",
        "师范类",
        "财经类",
        "体育类",
        "政法类",
        "军事类",
        "其他",
      ],
      }
    },
    mounted(){
      this.i = this.$route.query.i || null;
      if(this.$route.query.n){
        this.n = this.$route.query.n
        if(this.n=="zhaosheng"){
          this.title = "招生简章查询"
        }
        if(this.n=="zhongwai"){
          this.title = "中外合作"
        }
        if(this.n=="tuimian"){
          this.title = "推免院校"
        }
        if(this.n=="paihang"){
          this.title = "大学排行"
        }
        if(this.n=="baoyan"){
          this.title = "学校保研率"
        }
        if(this.n=="tuimian"){
          this.title = "具有研究生推免权院校"
        }
        if(this.n=="shuangyiliu"){
          this.title = "双一流学科查询"
        }
        if(this.n=="tesezhuanye"){
          this.title = "国家特色专业"
        }
        if(this.n=="zhongwai"){
          this.title = "中外合作办学"
        }
      }else{
        this.n = ""
        this.title = "院校信息库"
      }
      if(localStorage.getItem("qichengUserToken")){
        this.$store.dispatch("getUserInfo");
      }
      this.getList();
      console.log("userinfo",this.userinfo)
    },
    methods:{
      //详情
      detail(item){
        if(this.n=='zhaosheng'){
           window.open(item.zhaosheng,"_black");
        }else{
          // if(this.i ==1){
            let isCha=0;
            if(this.userinfo&&this.userinfo.role!=1){
              isCha=1
            }
            const routerUrl = this.$router.resolve({
              path: "/SchoolDetail?n=" + item.collegiate_id + "&i=" + this.i + "&fromList=" + this.fromList+'&isCha='+isCha,
            });
            window.open(routerUrl.href, "_blank");
          // }else{
          //    //此时需要先判断是否登录，是否为VIP
          //    this.$store.dispatch("isVipLogin").then(()=>{
          //      const routerUrl = this.$router.resolve({
          //        path: "/SchoolDetail?n=" + item.collegiate_id,
          //      });
          //      window.open(routerUrl.href, "_blank");
          //    })
          // }
        }
      },
      //搜索
      search(){
        this.form.page = 1
        this.getList();
      },
      //院校列表
      getList(){
        this.loading = true
        let form = {...this.form};
        if(this.n=="zhaosheng"){
          form["type"] = "8"
        }
        if(this.n=="zhongwai"){
          form["type"] = "9"
        }
        if(this.n=="tuimian"){
          form["type"] = "10"
        }
        if(this.n=="paihang"){
          form["type"] = "4"
        }
        if(this.n=="baoyan"){
          form["type"] = "3"
        }
        if(this.n=="tuimian"){
          form["type"] = "5"
        }
        if(this.n=="shuangyiliu"){
          form["type"] = "11"
        }
        if(this.n=="tesezhuanye"){
          form["type"] = "6"
        }
        if(this.n=="zhongwai"){
          form["type"] = "9"
        }
        collegeList(form).then(res=>{
          console.log("查院校",res.data);
          this.total = res.data.total
          this.list = res.data.data
          this.current_year = res.data.current
        }).finally(()=>{
          this.loading = false
        })
      },
     //院校所在地点击
     titleClick(title){
       this.form.page = 1
       this.form.collegeProvince = title
       this.getList();
     },
     //学历层次点击
     collegeLevelClick(title){
       this.form.page = 1
       this.form.collegeLevel = title
       this.getList();
     },
     //主管部门
     collegeNaturelClick(title){
       this.form.page = 1
       this.form.collegeNature = title
       this.getList();
     },
     collegeTypeClick(title){
      this.form.page = 1
      this.form.collegeType = title
      this.getList();
     },
     handleSizeChange(val) {
       console.log(`每页 ${val} 条`);
       this.form.limit = val
       this.getList()
     },
     handleCurrentChange(val) {
       console.log(`当前页: ${val}`);
       this.form.page = val
       this.getList()
     },
    },
  }
</script>

<style lang="scss" scoped>
.bottom{
  width: 100%;
  height: 60px;
  background: #fff;
    box-shadow: 0 0 8px #ddd;
  position: fixed;
  left: 0px;
  bottom: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
}
  .sch-level{
    margin-top: 10px;
    color: #666666;
        height: 22px;
        display: flex;
        align-items: center;
        width: fit-content;
  }
  .sch-levels{
    margin-top: 10px;
    color: #666666;
    width: 100%;
  }
  .lists{
    width:100%;
    display: flex;
    flex-wrap: wrap;
    .item-depart-title{
      color: #999999;
    }
    .col-line{
          color: #E7E7E7;
              padding: 0 10px;
    }
    .address{
      margin-top: 7px;
      color: #666666;
          height: 22px;
          display: flex;
          align-items: center;
          width: fit-content;
          .dingwei{
            width: 20px;
            height: 20px;
            margin-right:5px;
          }
    }
    .listcon{
      .info-box{
        flex: 1;
        font-size: 14px;
        .sch-title{
              display: flex;
              align-items: center;
              justify-content: space-between;
                  font-size: 16px;
                  line-height: 26px;
                  height: 26px;
        }
      }
      .logo{
            display: block;
            width: 68px;
            height: 68px;
            margin-right: 16px;
            img{
              width:100%;
              height: 100%;
              border-radius: 50%;
            }
      }
          box-sizing: border-box;
          padding: 20px 29px 22px;
          display: flex;
          align-items: center;
          width: calc(50% - 10px);
          background: #FFFFFF;
          margin-top: 20px;
          position: relative;
          margin-bottom: 20px;
    }
  }
  .list{
    width:1250px;
    margin:0 auto;
    min-height: 300px;
  }
  .item-options{
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        color: #333333;
  }
  .span{
    margin-right: 20px;margin-bottom: 10px;cursor: pointer;
  }
  .spanselect{
    color: #1CB278!important;
    font-weight: bold;
  }
  .span:hover{
    color: #1CB278!important;
  }
  .pri01{
    width: 84px;

    margin-right: 22px;
    color: #7B7B7B;
  }
  .pro{
    display: flex;
    flex-wrap: wrap;
  }
  .yuanxiaoku-sch-list-page{
    .yuanxiaoku-sch-list-pages{
      width: 1180px;
      margin: 0 auto;
    }
      width:1250px;
      margin: 0 auto;
      padding-top: 20px;
      padding-bottom: 20px;
      background: #FFFFFF;
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
  }
.school{
  width: 100%;
  .head{
    width: 100%;
    height: 148px;
    background: linear-gradient(180deg,#49c48d,#1cb278);
    background: url(../../assets/yuanxiaoku.jpg) no-repeat;
    background-size: 100%;
    line-height: 148px;
    text-align: center;
    font-size: 38px;
    font-weight: 600;
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/school/index.vue